import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { UserAvatarWithName } from "@/components/common/UserAvatarWithName";
import { Badge } from "@/components/ui/badge";
import type { SelectedRecipientsProps } from "@/features/chat/types";

export const SelectedRecipients = ({ recipients, onRemove }: SelectedRecipientsProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex max-h-24 min-h-10 flex-wrap gap-2 overflow-y-auto rounded-md bg-muted/30 p-2">
        {recipients.length > 0 ? (
          recipients.map((recipient) => (
            <Badge
              key={recipient.guid}
              variant="secondary"
              className="flex items-center gap-1 bg-white px-2 py-1"
            >
              <UserAvatarWithName user={recipient} size="sm" />
              <X
                size={14}
                className="cursor-pointer hover:text-destructive"
                onClick={() => onRemove(recipient)}
              />
            </Badge>
          ))
        ) : (
          <div className="flex w-full items-center justify-center py-2">
            <p className="text-muted-foreground text-sm">{t("chat.recipientsRequired")}</p>
          </div>
        )}
      </div>
      {recipients.length > 0 && (
        <p className="mt-2 text-[#565A5B] text-xs">
          {t("chat.selectedCount", { count: recipients.length })}
        </p>
      )}
    </div>
  );
};
